(function () {
  function buildIframe(embed, title) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', embed);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('title', title || 'Video player');
    return iframe;
  }

  function buildVideo(src, title) {
    var video = document.createElement('video');
    video.setAttribute('src', src);
    video.setAttribute('controls', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('title', title || 'Video player');
    return video;
  }

  function getData(el) {
    return {
      source: el.getAttribute('data-source') || '',
      embed: el.getAttribute('data-embed') || '',
      videoSrc: el.getAttribute('data-video-src') || '',
      orientation: el.getAttribute('data-orientation') || 'landscape',
      title: el.getAttribute('data-title') || ''
    };
  }

  function isPlayable(data) {
    return (data.source === 'cdn' && data.videoSrc) || (data.source === 'youtube' && data.embed);
  }

  function renderInto(container, data) {
    container.innerHTML = '';
    if (data.source === 'cdn') {
      var video = buildVideo(data.videoSrc, data.title);
      container.appendChild(video);
      video.play();
    } else {
      container.appendChild(buildIframe(data.embed, data.title));
    }
  }

  // Main featured video plays inline in its own player.
  function initMain(root) {
    var main = root.querySelector('.ryp-closer__main');
    if (!main) return;
    var player = main.querySelector('.ryp-closer__player');
    if (!player) return;

    main.addEventListener('click', function (e) {
      if (!e.target.closest('.ryp-closer__play')) return;
      var data = getData(main);
      if (isPlayable(data)) renderInto(player, data);
    });
  }

  // Slider thumbnails open the video in a modal.
  function initModal(root) {
    var thumbs = root.querySelectorAll('.ryp-closer__thumb');
    var modal = root.querySelector('[data-closer-modal]');
    if (!thumbs.length || !modal) return;

    var modalPlayer = modal.querySelector('.ryp-closer__modal-player');
    var dialog = modal.querySelector('.ryp-closer__modal-dialog');
    var closeBtn = modal.querySelector('.ryp-closer__modal-close');
    var lastFocused = null;

    function open(trigger) {
      var data = getData(trigger);
      if (!modalPlayer || !isPlayable(data)) return;
      lastFocused = trigger;
      if (dialog) dialog.classList.toggle('is-portrait', data.orientation === 'portrait');
      renderInto(modalPlayer, data);
      modal.hidden = false;
      document.body.classList.add('ryp-closer-modal-open');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      if (modalPlayer) modalPlayer.innerHTML = '';
      document.body.classList.remove('ryp-closer-modal-open');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { open(thumb); });
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-closer-modal-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initCarousel(root) {
    var viewport = root.querySelector('.ryp-closer__viewport');
    var track = root.querySelector('.ryp-closer__track');
    var prev = root.querySelector('.ryp-closer__nav--prev');
    var next = root.querySelector('.ryp-closer__nav--next');
    var slides = track ? track.querySelectorAll('.ryp-closer__thumb') : [];

    if (!viewport || !track || !slides.length) return;

    var index = 0;

    function getStep() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function getPerView() {
      var step = getStep();
      if (step <= 0) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return Math.max(1, Math.floor((viewport.getBoundingClientRect().width + gap) / step));
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getPerView());
    }

    function update() {
      var maxIndex = getMaxIndex();
      if (index > maxIndex) index = maxIndex;
      if (index < 0) index = 0;

      track.style.transform = 'translateX(' + -(index * getStep()) + 'px)';

      var single = slides.length <= getPerView();
      if (prev) {
        prev.hidden = single;
        prev.disabled = index <= 0;
      }
      if (next) {
        next.hidden = single;
        next.disabled = index >= maxIndex;
      }
    }

    if (prev) prev.addEventListener('click', function () { index -= 1; update(); });
    if (next) next.addEventListener('click', function () { index += 1; update(); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 150);
    });

    update();
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('[data-section-type="ryp-closer-look"]');
    sections.forEach(function (root) {
      initMain(root);
      initModal(root);
      initCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) initAll(e.target);
  });
})();
